import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { AddHallpassComponent } from "../../../shared/manual-sidebar/hallpass-menu/add-hallpass/add-hallpass.component";
import { ScanPointManualAddHallPassComponent } from "../../time-scan-manual-bar/scan-point-manual-hall-pass/scan-point-manual-add-hall-pass/scan-point-manual-add-hall-pass.component";

@Component({
	selector: "caass-time-scan-entry",
	templateUrl: "./time-scan-entry.component.html",
	styleUrls: ["./time-scan-entry.component.css"],
})
export class TimeScanEntryComponent implements OnInit {
	constructor(private dialogService: DialogService) {}

	ngOnInit(): void {
		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	@Input() ScanInfo: any = null;

	Processing: boolean = false;
	ScannerNBR: string = "S";
	PersonTypeID: number = -1;
	AlertSeverity: number = -1;
	PhotoData: string = "";
	ShowIcoAttendance: boolean = false;
	ShowIcoError: boolean = false;
	ShowIcoHallPass: boolean = false;
	ShowIcoInfo: boolean = false;
	ShowIcoPlus: boolean = false;
	ShowIcoQuestion: boolean = false;
	ShowIcoWarning: boolean = false;
	PersonName: string = "";
	DesignatorID: string = "";
	Alert1: string = "";
	Alert2: string = "";
	Status: string = "";
	StationReminderAlert: any;
	lstReminders: any = [];
	SelectedAlert: any;
	lstAlerts: any = [];
	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////

	UpdateData() {
		this.Processing = true;

		if (this.ScanInfo != null) {
			if (this.ScanInfo.Success == true) {
				//
				// Init Basic Data
				//
				this.ScannerNBR = this.ScanInfo.IsManual == true ? "M" : "S";

				this.PersonName = this.ScanInfo.PersonName;
				this.DesignatorID = this.ScanInfo.DesignatorID;
				this.PersonTypeID = this.ScanInfo.PersonTypeID;

				if (this.ScanInfo.PhotoData != "") {
					this.PhotoData = this.ScanInfo.PhotoData;
				} else {
					this.PhotoData = "assets/images/ScanPointImages/CardNoPhoto.png";
				}

				//
				// Reminders
				//
				this.lstReminders = this.ScanInfo.lstReminders;

				if (this.lstReminders.length > 0) {
					// this.lstReminders.unshift({
					//   StationReminderAlertID: -1,
					//   Message: "",
					//   MessageFontColor: "Black"
					// });

					this.StationReminderAlert = this.lstReminders[0];
				} else {
					this.StationReminderAlert = null;
				}

				//
				// Alerts
				//
				this.lstAlerts = this.ScanInfo.lstAlerts;

				if (this.lstAlerts.length > 0) {
					// this.lstAlerts.unshift({
					//   AlertID: -1,
					//   Message: "",
					//   MessageFontColor: "Black"
					// });

					this.SelectedAlert = this.lstAlerts[0];
				} else {
					this.SelectedAlert = null;
				}

				// // this.AlertSeverity = this.ScanInfo.lstAlerts[0].AlertSeverityID;
				if (this.ScanInfo.Override == false && this.ScanInfo.BelongsInFacility == 0) {
					this.GetWrongFacilityStatus();
				} else if (this.ScanInfo.lstAlerts.length > 0) {
					// Normal Bad Scan:
					if (this.ScanInfo.Override == false) {
						this.GetAlertStatus();
					}
					// Override and admit the student anyways
					else {
						this.GetGoodStatusWithAlerts();
					}
				} else {
					this.GetGoodStatus();
				}
			}
			//
			// Error While Scanning (Invalid Barcode or other error)
			//
			else {
				this.GetInvalidImageAndData();
			}
		}

		this.Processing = false;
	}

	GetWrongFacilityStatus() {
		this.AlertSeverity = 1;
		this.ShowIcoError = true;
		this.Status = "Deny Access\n" + (this.PersonTypeID == 1 ? "Student" : "Staff") + " Not Authorized in this Facility";

		//Also get alerts
		if (this.ScanInfo.lstAlerts.length > 0) {
			this.Alert1 = this.ScanInfo.lstAlerts[0].Message;
			if (this.ScanInfo.lstAlerts.length > 1) {
				this.Alert2 = this.ScanInfo.lstAlerts[1].Message;
			}
		}
	}

	GetAlertStatus() {
		//Init Alert Severity
		this.AlertSeverity = this.ScanInfo.lstAlerts[0].AlertSeverityID;
		if (this.ScanInfo.lstAlerts.length > 1) {
			for (var i = 0; i < this.ScanInfo.lstAlerts.length; i++) {
				var nextSev = this.ScanInfo.lstAlerts[i].AlertSeverityID;

				//Get lowest alert level (1 is worst, 3 is not as bad)
				if (nextSev < this.AlertSeverity) {
					this.AlertSeverity = nextSev;
				}
			}
		}

		if (this.ScanInfo.Override == false && this.AlertSeverity == 1) {
			this.Status = "Deny Entry\nSeverity " + this.AlertSeverity + " Alert";
			this.ShowIcoError = true;
		} else {
			if (String(this.ScanInfo.TimeScanTypeDesc).toLowerCase().includes("scan")) {
				this.Status = "Student has a Severity " + this.AlertSeverity + " Alert\n" + this.ScanInfo.TimeScanTypeDesc + " Recorded";
			} else {
				this.Status = "Student has a Severity " + this.AlertSeverity + " Alert\n" + this.ScanInfo.TimeScanTypeDesc + " Scan Recorded";
			}

			if (this.AlertSeverity == 2) {
				this.ShowIcoWarning = true;
			} else if (this.AlertSeverity == 3) {
				this.ShowIcoInfo = true;
			}
		}

		this.Alert1 = this.ScanInfo.lstAlerts[0].Message;
		if (this.ScanInfo.lstAlerts.length > 1) {
			this.Alert2 = this.ScanInfo.lstAlerts[1].Message;
		}
	}

	GetGoodStatusWithAlerts() {
		this.GetGoodStatus();

		var maxSev = this.ScanInfo.lstAlerts[0].AlertSeverityID;
		if (this.ScanInfo.lstAlerts.length > 1) {
			for (var i = 0; i < this.ScanInfo.lstAlerts.length; i++) {
				var nextSev = this.ScanInfo.lstAlerts[i].AlertSeverityID;

				//Get lowest alert level (1 is worst, 3 is not as bad)
				if (nextSev < maxSev) {
					maxSev = nextSev;
				}
			}
		}

		if (maxSev == 1) {
			this.Status = "Overriding Deny Entry:\n(STUDENT SHOULD NOT ENTER WITH SEVERITY " + maxSev + " ALERT)";
		} else if (maxSev != 0) {
			this.Status = "Overriding Deny Entry: \nStudent has a Severity " + maxSev + " Alert";
		}

		if (this.ScanInfo.BelongsInFacility == 0) {
			this.Status += "\nStudent does not belong in this facility";
		}

		this.Alert1 = this.ScanInfo.lstAlerts[0].Message;
		if (this.ScanInfo.lstAlerts.length > 1) {
			this.Alert2 = this.ScanInfo.lstAlerts[1].Message;
		}
	}

	GetGoodStatus() {
		//Good scan options
		if (this.ScanInfo.Success == false) {
			if (String(this.ScanInfo.TimeScanTypeDesc).toLowerCase().includes("scan")) {
				this.Status = this.ScanInfo.TimeScanTypeDesc + " Recorded";
			} else {
				this.Status = this.ScanInfo.TimeScanTypeDesc + " Scan Recorded";
			}
		}

		this.ShowIcoAttendance = true;
		if (this.PersonTypeID == 1) {
			this.ShowIcoHallPass = true; ////////
		}
	}

	GetInvalidImageAndData() {
		this.PersonTypeID = -1;

		this.AlertSeverity = 1;
		this.PersonName = "";
		this.DesignatorID = "";
		this.Status = "Deny Access\nBad Card";

		//Main image for bad scan:
		if (this.ScanInfo != null) {
			if (this.ScanInfo.BarcodeStatusID == 1) {
				this.PhotoData = "assets/images/ScanPointImages/CardLost.png";
				this.Status = "Card Lost";
			} else if (this.ScanInfo.BarcodeStatusID == 2) {
				this.PhotoData = "assets/images/ScanPointImages/CardStolen.png";
				this.Status = "Card Stolen";
			} else if (this.ScanInfo.BarcodeStatusID == 3) {
				this.PhotoData = "assets/images/ScanPointImages/CardForgotten.png";
				this.Status = "Card Forgotten";
			} else if (this.ScanInfo.BarcodeStatusID == 4) {
				this.PhotoData = "assets/images/ScanPointImages/CardBroken.png";
				this.Status = "Card Broken";
			} else if (this.ScanInfo.BarcodeStatusID == 5) {
				this.PhotoData = "assets/images/ScanPointImages/CardExpired.png";
			} else if (this.ScanInfo.BarcodeStatusID == 6) {
				this.PhotoData = "assets/images/ScanPointImages/CardRevoked.png";
				this.Status = "Card Expired";
			} else if (this.ScanInfo.BarcodeStatusID == 7) {
				this.PhotoData = "assets/images/ScanPointImages/CardUnderConstruction.png";
				this.Status = "Card Under Construction";
			} else if (this.ScanInfo.BarcodeStatusID == 8) {
				this.PhotoData = "assets/images/ScanPointImages/CardInactive.png";
				this.Status = "Card Inactive";
			} else {
				this.PhotoData = "assets/images/ScanPointImages/CardInvalid.png";
			}
		} else {
			this.PhotoData = "assets/images/ScanPointImages/CardInvalid.png";
		}

		this.ShowIcoError = true;
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////

	onHallPass() {
		console.log(this.ScanInfo);

		var ref = this.dialogService.open(ScanPointManualAddHallPassComponent, {
			header: "Add Hall Pass",
			width: "fit-content",
			data: {
				PersonID: this.ScanInfo.PersonID,
				PersonName: this.ScanInfo.PersonName,
				DesignatorID: this.ScanInfo.DesignatorID,
				SelectedFacilityID: this.ScanInfo.FacilityID,
				SelectedFacilityLocationID: this.ScanInfo.FacilityLocationID,
				SelectedPrinterID: this.ScanInfo.Receipt_IDPrinterID,
			},
		});
		ref.onClose.subscribe((response) => {});

		//Create Popup
		// var ref = this.dialogService.open(AddHallpassComponent, {
		//   header: "Add Hall Pass",
		//   width: 'fit-content',
		//   data: {
		//     SelectedPerson: {
		//       PersonID: this.ScanInfo.PersonID,
		//       PersonName: this.ScanInfo.PersonName,
		//       ID: this.ScanInfo.DesignatorID
		//     },
		//     SelectedFacilityID: this.ScanInfo.FacilityID,
		//     SelectedFacilityLocationID: this.ScanInfo.FacilityLocationID,
		//     SelectedPrinterID: this.ScanInfo.Receipt_IDPrinterID
		//   }
		// });
		// ref.onClose.subscribe((response) => {
		// });
	}

	/////////////////////////////////////////////////////////////////
}
